import script from "./LanguageToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageToggle.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageToggle.vue?vue&type=style&index=0&id=21f696c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f696c3"]])

export default __exports__